import moment from "moment";
import { decryptedData } from "./encryptDecryptData";
import { formatCurrency } from "./numberFormat";

// Pending Actions type for an investor cancellation request awaiting review.
// Separate from "cancelInvestment" (an approved/automatic cancellation that
// needs manual repayment).
export const CANCEL_REQUEST_ACTION_TYPE = "cancelRequest";

// "Investor (Campaign) • amount • Requested on <date> • Pending approval"
export const getCancelRequestSummary = (item, intl, generalSettings) => {
  const investor = `${decryptedData(item?.userId?.firstName) ?? ""} ${
    decryptedData(item?.userId?.lastName) ?? ""
  }`.trim();
  const campaign = decryptedData(item?.companyId?.companyName);

  const rawAmount = item?.preapprovalTotalAmount ?? item?.amount;
  const amount =
    rawAmount === undefined || rawAmount === null
      ? null
      : formatCurrency(
          rawAmount,
          generalSettings?.currencySymbolSide,
          item?.equityCurrencySymbol,
          item?.equityCurrencyCode,
          generalSettings?.decimalPoints
        ) ??
        // formatCurrency returns nothing until the symbol-side setting loads.
        `${item?.equityCurrencySymbol ?? ""}${Number(rawAmount).toLocaleString()}`;

  const requestedOn = item?.cancelRequestDate
    ? intl.formatMessage(
        { id: "INVESTMENT.CANCEL.REQUEST.REQUESTED.ON" },
        {
          date: moment(item.cancelRequestDate).format(
            generalSettings?.dateFormat || "DD MMM YYYY"
          ),
        }
      )
    : null;

  return [
    campaign ? `${investor} (${campaign})` : investor,
    amount,
    requestedOn,
    intl.formatMessage({ id: "INVESTMENT.CANCEL.PENDING.ACTION.STATUS" }),
  ]
    .filter(Boolean)
    .join(" • ");
};

// Campaign Details, opened on the Investor tab where the request is reviewed.
// transactionId lets the page locate the investment the action is about.
export const getCancelRequestNavigation = (item) => ({
  path:
    "/campaign/campaign-details/" +
    (item?.campaignId || item?.companyId?.campaignId),
  options: { state: { tab: "investor", transactionId: item?.id } },
});

// "cancelInvestment" (manual repayment required) lands on the same tab.
export const getCancelInvestmentNavigation = (item) => ({
  path: "/campaign/campaign-details/" + item?.companyId?.campaignId,
  options: { state: { tab: "investor", transactionId: item?.id } },
});
